module.exports = __webpack_public_path__ + "img/alberto-de-belaunde.83f7f18f.png";